import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "end-settlement" }
const _hoisted_2 = { class: "end-settlement_greeting flex-column justify-center" }
const _hoisted_3 = { class: "greeting-emoji" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "settle-text flex-column justify-evenly" }

import { actionSheetController, IonButton, modalController } from "@ionic/vue";
import http from "@/js/http";
import store from "@/js/store";
import { useRoute, useRouter } from "vue-router";
import { onBeforeUnmount, ref } from "vue";
import { openMsgToast } from "@/views/AIGenerate/openModal";
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore";
import { getBrandImageUrl } from "@/js/brandImages";


export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleEndModal',
  props: ["readingId", "fromPrepareOrigin"],
  setup(__props) {

const props = __props;
const router = useRouter();
const route = useRoute();
const studentInfo = ref();
const stepStore = useCurrentStepStore();

async function endTheExercise() {
  if (!props.fromPrepareOrigin) {
    await finishReadingArticleLearning();
  }
  stepStore.initStepNum();
  stepStore.control3SecondsVisible();
  store.clearStudentInfoSession();
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
  await modalController
    .dismiss()
    .then()
    .catch((e) => console.log(e));
}

//结束一篇文章的练习
async function finishReadingArticleLearning() {
  const appointment = store.getAppointment();
  await http.post("/reading/finishReadingArticleLearning", {
    readingId: props.readingId,
    studentId: appointment.studentId,
    aptmId: appointment.aptmId,
  });
}

async function showTeacherSelect(aptmId: any) {
  if (!props.fromPrepareOrigin) {
    await finishReadingArticleLearning();
  }
  return new Promise((resolve, reject) => {
    let buttons = [];
    for (let i = 5; i < 24; i++) {
      let fill = i < 10 ? "0" : "";
      let time1 = fill + i + ":00";
      let time2 = fill + i + ":30";
      let params1 = { aptmId: aptmId, startTime: time1 };
      let params2 = { aptmId: aptmId, startTime: time2 };
      buttons.push({
        text: time1,
        handler: async () => {
          if (props.fromPrepareOrigin) { // 备课模式下，直接结束练习
            await openMsgToast("21天抗遗忘创建成功。");
            await modalController.dismiss({ type: "TEXT" });
            resolve("");
            return;
          }
          requestGenerateForget(params1)
            .then(() => {
              resolve("");
            })
            .catch((e) => {
              reject(e);
            });
        },
      });

      buttons.push({
        text: time2,
        cssClass: "teacherSelectButtons",
        handler: () => {
          if (props.fromPrepareOrigin) { // 备课模式下，直接结束练习
            openMsgToast("21天抗遗忘创建成功。");
            modalController.dismiss({ type: "TEXT" });
            resolve("");
            return;
          }
          requestGenerateForget(params2)
            .then(() => {
              resolve("");
            })
            .catch((e) => {
              reject(e);
            });
        },
      });
    }

    actionSheetController
      .create({
        header: "选择抗遗忘时间",
        buttons: buttons,
      })
      .then((actionSheet) => {
        actionSheet.present();
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function requestGenerateForget(params: any) {
  return new Promise((resolve: any) => {
    http.post("/forget/generateForget", params).then(async (res: any) => {
      if (res.data.success) {
        await openMsgToast("21天抗遗忘创建成功。");
        await modalController.dismiss({ type: "TEXT" });
        resolve();
      }
    });
  });
}

async function createForgettable() {
  stepStore.initStepNum();
  const appointment = store.getAppointment();
  await showTeacherSelect(appointment.aptmId);
  store.clearStudentInfoSession();
  store.setStudentId(appointment.studentId);
  localStorage.setItem("appointment", JSON.stringify(appointment));
}

onBeforeUnmount(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "encourage-label" }, [
        _createElementVNode("span", null, "恭喜！"),
        _createTextVNode("完成本次阅读理解训练")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "greeting-emoji_bg",
          src: _unref(getBrandImageUrl)('ai_smart_reading/end_exercise_fireworks.png'),
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          class: "greeting-emoji_image",
          src: _unref(getBrandImageUrl)('ai_smart_reading/end_exercise_happy.png'),
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "next-text" }, [
          _createTextVNode("解锁下一篇，添加知识点"),
          _createElementVNode("br"),
          _createTextVNode("至打印页面")
        ], -1)),
        _createVNode(_unref(IonButton), {
          class: "end-exercise",
          shape: "round",
          onClick: endTheExercise
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("返回首页")
          ])),
          _: 1,
          __: [0]
        }),
        _createElementVNode("div", {
          class: "create-forgetfulness text-center common-color mt-3 cursor-pointer",
          onClick: createForgettable
        }, " 结束并创建抗遗忘 ")
      ])
    ])
  ]))
}
}

})